import { memo } from 'react';
import type { ReactNode } from 'react';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface CustomColorType {
  bgColor?: string;
  pointColor?: string;
  emphasisTextColor?: string;
}

type ColorType = 'black' | 'gray' | CustomColorType | string;

interface IProps {
  type?: 'list' | 'count' | string;
  colorType?: ColorType;
  title?: string;
  desc?: ReactNode;
  count?: number;
}

const CouponItem3 = ({
  type = 'list',
  colorType = 'black',
  title,
  desc,
  count,
}: IProps) => {
  const isCustomColor = typeof colorType === 'object';
  const customColors = isCustomColor ? colorType : undefined;

  const cName = classNameBind([
    'coupon-item item',
    `type-${type}`,
    !isCustomColor ? `bg-type-${colorType}` : '',
  ]);

  return (
    <S.CouponItem3
      className={cName}
      $type={type}
      $bgColor={customColors?.bgColor}
      $pointColor={customColors?.pointColor}
      $emphasisTextColor={customColors?.emphasisTextColor}
    >
      <div className="text-wrap">
        {title && <Text className="title">{title}</Text>}
        {desc && <Text className="desc">{desc}</Text>}
      </div>
      {type === 'count' && (
        <div className="area-cnt">
          {(count as number) > 0 && (
            <Text size={14} lineHeight="130%" block>
              <em>{count}</em>장
            </Text>
          )}
        </div>
      )}
    </S.CouponItem3>
  );
};

export default memo(CouponItem3);
